import type { PipCorner } from "../../store/streamPipStore";

export const CARD_WIDTH = { sm: 240, md: 360 } as const;

/** The mobile bottom tab bar owns the last 56px of the viewport. */
export const MOBILE_NAV_HEIGHT = 56;

/** Mobile dock anchors to the top (below the 56px header), like Android, so it never covers the chat composer. */
export const MOBILE_DOCK_TOP = "calc(56px + env(safe-area-inset-top, 0px))";

/**
 * Mobile, while a post dialog is open (its close and menu are at the top): the dock sits at the bottom, just above
 * the tab bar.
 */
export const MOBILE_DOCK_GAP = 8;
export const MOBILE_DOCK_BOTTOM = `calc(${MOBILE_NAV_HEIGHT + MOBILE_DOCK_GAP}px + env(safe-area-inset-bottom, 0px))`;

/** An upward swipe this long (px) on the mini player opens the dock (Android MiniSwipeOpen 48dp). */
export const MINI_SWIPE_OPEN = 48;

/** Desktop, while a post dialog is open (its comments input is bottom-right): the dock's corner. */
export const AVOID_CORNER: PipCorner = "tl";

export function cornerStyle(corner: PipCorner): React.CSSProperties {
  const vertical = corner.startsWith("t") ? { top: 12 } : { bottom: 12 };
  const horizontal = corner.endsWith("l") ? { left: 12 } : { right: 12 };
  return { ...vertical, ...horizontal };
}

/** The Document PiP window's size for one card (16:9 player plus header and controls). */
export const PIP_WINDOW_SIZE = {
  width: CARD_WIDTH.md,
  height: Math.round((CARD_WIDTH.md * 9) / 16) + 64,
} as const;
